import React from 'react';
import MobileDefaultLayout from 'app/Layouts/DefaultLayout/MobileDefaultLayout';
import HomeWidgets from './HomeWidgets';

const Home = () => (
  <MobileDefaultLayout navbarProps={{}}>
    <HomeWidgets spacing={2} />
  </MobileDefaultLayout>
);

export default Home;
